<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <v-container>
                <v-row dense class="flex ma-2 mb-4">
                    <div :style="{color: 'black'}" class="mr-3">Photo nr: {{ hsft.hsft_nr }}</div>
                    <div :style="{color: 'black'}" class="mr-3">Accommodation: {{ hsft.hsft_huis_code }}</div>
                </v-row>
                <v-row dense class="flex mx-2">
                    <v-select v-model="hsft.fttg_nr" :items="fttg_nrKeuzes" item-value="fttg_nr" item-text="fttgtaal_oms" label="Tag" dense></v-select>
                </v-row>   
                <v-row dense class="flex mx-2">
                    <v-select v-model="hsft.hsft_bewerkt" :items="hsft_bewerktKeuzes" item-value="value" item-text="oms" label="Image Adjustment" dense></v-select>
                </v-row>   
                     
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="primary mr-2" small @click="saveHsft2">Save</v-btn>
                    <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
// import { bus } from "../../../main";
export default {
    data() { 
        return {
            dialog: false,
            hsft_encrid: '',
            fttg_nrKeuzes: [],
            hsft_bewerktKeuzes: [],
            vlgn_nrKeuzes: [],
            hsft: {}
        }
    },
    methods: {
        open(hsft_encrid) {
            this.hsft_encrid = hsft_encrid;
            this.$emit("showSnackbar");
            this.dialog = true;
            this.$axios
                .post("ares/json/ares/huis/hsft/getHsftToUpdHsft.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHsftToUpdHsft"
                    },
                    getHsftToUpdHsft: {
                        hsft_encrid: hsft_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hsft = res.data.getHsftToUpdHsft;
                        this.fttg_nrKeuzes = res.data.getHsftToUpdHsft.fttg_nrKeuzes;
                        this.hsft_bewerktKeuzes = res.data.getHsftToUpdHsft.hsft_bewerktKeuzes;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        saveHsft2() {
            this.$axios
                .post("ares/json/ares/huis/hsft/saveHsft2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveHsft2"
                    },
                    saveHsft2: {
                        hsft_encrid: this.hsft.hsft_encrid,
                        fttg_nr: parseInt(this.hsft.fttg_nr),
                        hsft_bewerkt: this.hsft.hsft_bewerkt
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        if (res.data.saveHsft2.color == "success") {
                            // get the description by key value
                            let idx = this.fttg_nrKeuzes.findIndex(fttg => fttg.fttg_nr === this.hsft.fttg_nr)
                            console.log(idx,this.hsft_encrid,this.hsft.fttg_nr,this.fttg_nrKeuzes[idx].fttgtaal_oms);
                            this.$emit("updateData", [
                               { field: "hsft_encrid", value: this.hsft_encrid },
                               { field: "fttg_nr", value: this.hsft.fttg_nr },
                               { field: "fttgtaal_oms", value: this.fttg_nrKeuzes[idx].fttgtaal_oms }
                            ]);
                            //this.getHuisData('update');
                        }
                        
                        this.$emit("updateHsft");
                        this.dialog = false;
                        // bus.$emit("closeDialog", "reload");
                        
                    }
                })
        },
        updateData() {
            this.getHuisData('update');
        },
    }
}
</script>
<style scoped>
    .flex{
        display: flex;
        flex-direction: row;
    }
</style>  